import { Injectable } from '@angular/core';
import { DataService } from '../data.service';
import { Normative } from '../../model/normative';

@Injectable({
  providedIn: 'root'
})
export class NormativeService {

  constructor( private dataService: DataService ) { }

  private readonly getByParametersEndPoint: string =
          '/normative/getByParameters/';

  async getByParameters(
    agreementPriceIds: number[],
    planId: number,
    medicalAppointmentId?: number ): Promise<Normative> {

    const param = {
      AgreementPriceIds: agreementPriceIds,
      PlanId: planId,
      MedicalAppointmentId: medicalAppointmentId
    };

    return await this.dataService
          .get<Normative>(this.getByParametersEndPoint, param)
          .toPromise();
  }
}
